These indicate features that may be available (via a relationship or for all SEEK hirers) but have been disabled by a hirer.
They are separate from relationship types.

Currently, the following feature codes are defined:

- `CandidateVerification` disables the Verify with SEEK Pass functionality for the hirer, even if the partner has a relationship type that would normally allow it.
  This also disables the ability to query for candidate identity verifications.
